import { SvgIconProps } from '@traba/types'

const Play = ({ size, color, strokeWidth, ...props }: SvgIconProps) => {
  return (
    <svg
      className="button"
      viewBox="0 0 60 60"
      width={size}
      height={size}
      {...props}
    >
      <polygon points="0,0 50,30 0,60" fill={color} strokeWidth={strokeWidth} />
    </svg>
  )
}

export default Play
